const isDebug = process.env.REACT_APP_DEBUG === "TRUE";

const logger = {
  log: (...args) => isDebug && console.log(...args),
  warn: (...args) => isDebug && console.warn(...args),
  error: (...args) => isDebug && console.error(...args),
};

export default logger;
